<template>
  <v-container fluit>
    <v-card flat class="d-flex justify-center py-10">
      <v-row justify="center">
        <v-col :cols="11" :xs="10" :sm="10" :md="8" lg="auto" xl="auto">
          <span class="display-1 text-center font-weight-bold">{{
            notification
          }}</span>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      notification: "No data matching this query!"
    };
  },
  computed: {
    ...mapState(["errorMsg"])
  },
  created() {
    this.notification = this.errorMsg;
    if (
      this.$router.currentRoute.params &&
      this.$router.currentRoute.params.errorMsg &&
      this.$router.currentRoute.params.errorMsg.length > 0
    ) {
      this.notification = this.$router.currentRoute.params.errorMsg;
    }
  }
};
</script>
>
